import { ErrorPage } from "@payping/icons";
import classNames from "clsx";
import { useAppTranslation } from "@/utils";
import { Button, Col, Row, Typography } from "@payping/web-components";
import { ErrorBoundaryProps, ErrorBoundaryType } from "./types";

export const ErrorBoundary: ErrorBoundaryType = ({ ...props }: ErrorBoundaryProps) => {
  const { t } = useAppTranslation();
  return (
    <Row justify="center" align="middle" gutter={{ md: 48 }} className={classNames(`payping-errorBoundaryBackground`)}>
      <Col md={8} xs={16} className={"p-3"}>
        <ErrorPage />
      </Col>
      <Col md={8} xs={16}>
        <Typography.Title>{t("components.errorBoundary.title")}</Typography.Title>
        <br />
        <Typography.Paragraph>{t("components.errorBoundary.description")}</Typography.Paragraph>
        <br />
        <Button variant={"solid"} color="blue" size={"large"} onClick={props.onRefreshAppClick}>
          {t("common.restart")}
        </Button>
      </Col>
    </Row>
  );
};
